import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment';
import { getFirstDayOfWeek, getLastDayOfWeek } from '../DateHelper';

@Pipe({
  name: 'weeknumber'
})
export class WeekNumberPipe implements PipeTransform {
  transform(value: Date) : string {

    if (!value) {
      return '';
    }

    // First day of the week is sunday, last is saturday
    return getFirstDayOfWeek(value).format('DD/MM/YYYY') + ' hasta ' +
           getLastDayOfWeek(value).format('DD/MM/YYYY')
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/weeknumber.ts